import React from 'react'

const FormContext = React.createContext({
  values: {},
  errors: {},
  touched: {},
  setFieldValue: () => {},
  setFieldTouched: () => {},
  handleSubmit: () => {}
})

export const withFormContext = (Component) => (props) => (
  <FormContext.Consumer>
    {(formirkProps) => (<Component {...props} form={formirkProps} />)}
  </FormContext.Consumer>
)

export const useFormContext = () => {
  const formikProps = React.useContext(FormContext)
  return formikProps
}

export default FormContext
